export const EMPTY_DROPDOWN_LIST_SYMBOL = '-';
